module.exports = __webpack_public_path__ + "static/salesforce_accounts-1f185a59f47b0185f33f4f9310e7baae.png";